/**
 * Ensures a URL string starts with a protocol (http:// or https://).
 * If the URL doesn't include a protocol, https:// is prepended.
 * Returns an empty string if the input is falsy.
 */
export const ensureHttpProtocol = (url?: string | null): string => {
	if (!url) {
		return "";
	}

	return url.match(/^https?:\/\//) ? url : `https://${url}`;
};
